import { useGoBackEvent } from "app/hooks/go-back.hook";
import { useArrowKeyNavigationOverlay } from "app/hooks/keyboard-navigation.hook";
import useModalScroll from "app/hooks/modal-scroll.hook";
import { useCallback, useRef } from "react";
import { useGetPillowCategoriesPath } from "services-hooks/hooks";
import { Category } from "services-hooks/types";
import { BackButtonBar } from "../back-button/back-button.component";
import { CountryList } from "../country-list/country-list.component";
import Loader from "../icons/Loader";
import styles from "./country-selector.module.scss";

interface CountrySelectorProps {
  onClose: VoidFunction;
  onSelect: (country: Category) => void;
}
export const CountrySelector: React.FC<CountrySelectorProps> = ({
  onClose,
  onSelect,
}) => {
  const wrapperRef = useArrowKeyNavigationOverlay();
  const loadMoreTriggerRef = useRef(null);
  const { data, isLoading, fetchNextPage } = useGetPillowCategoriesPath(
    "/radioline_geo",
    {
      pageSize: 100,
    }
  );
  useModalScroll();
  const goBackCallback = useCallback(() => {
    onClose();
  }, [onClose]);
  useGoBackEvent("CountrySelector", goBackCallback);
  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <BackButtonBar onClick={onClose} />
      <div className={styles.content}>
        <div className={styles.countries_wrapper}>
          {isLoading ? (
            <div className={styles.loader_container}>
              <Loader />
            </div>
          ) : (
            <>
              {data?.pages.map((countryPage) => {
                return countryPage.data.body?.content?.map((countryRegion) => {
                  return (
                    <CountryList
                      regionPermalink={countryRegion.permalink!}
                      label={countryRegion.name}
                      showNames
                      onSelect={onSelect}
                    />
                  );
                });
              })}
              <div ref={loadMoreTriggerRef} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
